import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { publicApi } from '@/utils/api';
import { manualApprovalBuildListPath } from '@/utils/publicApiRouteService';

type UseManualApprovalBuildListProps = {
  appSlug: string;
  enabled: boolean;
};

export type ManualApprovalBuild = {
  slug: string;
  pullRequestUrl: string;
  createdAt: string;
  buildParams: {
    commitHash: string;
    commitMessage: string;
    tag?: string;
    branch: string;
    branchRepoOwner: string;
    branchDest: string;
    branchDestRepoOwner: string;
    pullRequestId: number;
    pullRequestRepositoryUrl: string;
    baseRepositoryUrl: string;
    headRepositoryUrl: string;
    pullRequestUnverifiedMergeBranch: string;
    pullRequestHeadBranch: string;
    pullRequestAuthor: string;
    pullRequestMergeBranch?: string;
    diffUrl: string;
    commitPaths?: string;
  };
};

export type UseManualApprovalBuildListResponse = AxiosResponse<ManualApprovalBuild[] | []>;

const useManualApprovalBuildList = ({ appSlug, enabled }: UseManualApprovalBuildListProps) => {
  return useQuery({
    queryKey: ['manual-approval-builds', appSlug],

    queryFn: async () => {
      const { data: response } = await publicApi.get<UseManualApprovalBuildListResponse>(
        manualApprovalBuildListPath(appSlug),
      );
      return response.data;
    },

    enabled,
  });
};

export default useManualApprovalBuildList;
